import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import Select from 'react-select';

import { fontStyles, subNutritionRowStyles } from 'components/shared/nutrition_facts/sharedStyles';
import Separator from 'components/shared/nutrition_facts/Separator';
import { updateAttributeValueByName } from 'components/nutritional_panels/ProductNutritionFactsForEdit';

function AddedSugarsRow({
  quantity,
  uom,
  percentage,
  precisionCode,
  setNutritionAttributes,
  quantityAttribute,
  uomAttribute,
  percentageAttribute,
  precisionCodeAttribute,
}) {
  const options = [{ value: 'Less Than', label: '<' }];

  const handlePrecisionChange = selectedOption => {
    const newValue = selectedOption ? selectedOption.value : '';
    updateAttributeValueByName(setNutritionAttributes, precisionCodeAttribute, newValue);
  };

  return (
    <>
      <div className="w-100 d-flex justify-content-between">
        <div
          className={classNames(
            css(subNutritionRowStyles(2).titleContainer),
            fontStyles('16px'),
            'd-flex gap-2 my-1',
          )}
        >
          Includes
          {precisionCodeAttribute && (
            <div className={css(styles.selectContainer)}>
              <Select
                value={options.find(option => option.label === precisionCode)}
                onChange={handlePrecisionChange}
                options={options}
                isClearable={true}
                placeholder=""
                className={css(styles.select)}
                classNamePrefix="react-select"
                styles={{
                  control: baseStyles => ({
                    ...baseStyles,
                    minHeight: '28px',
                    height: '28px',
                  }),
                  valueContainer: baseStyles => ({
                    ...baseStyles,
                    padding: '0 8px',
                  }),
                  indicatorsContainer: baseStyles => ({
                    ...baseStyles,
                    height: '28px',
                  }),
                }}
              />
            </div>
          )}
          <input
            type="text"
            value={quantity || ''}
            className={`form-control form-control-sm mx-1 ${css(styles.input)}`}
            placeholder="Quantity"
            onChange={e =>
              updateAttributeValueByName(setNutritionAttributes, quantityAttribute, e.target.value)
            }
          />
          <input
            type="text"
            value={uom || ''}
            className={`form-control form-control-sm mr-1 ${css(styles.input)}`}
            placeholder="Uom"
            onChange={e =>
              updateAttributeValueByName(setNutritionAttributes, uomAttribute, e.target.value)
            }
          />
          Added Sugars
        </div>
        {percentageAttribute && (
          <div className="d-flex my-1">
            <input
              type="text"
              value={percentage || ''}
              className={`form-control form-control-sm ${css(styles.input)}`}
              placeholder="Percentage"
              onChange={e =>
                updateAttributeValueByName(
                  setNutritionAttributes,
                  percentageAttribute,
                  e.target.value,
                )
              }
            />
            %
          </div>
        )}
      </div>
      <Separator />
    </>
  );
}

const styles = StyleSheet.create({
  input: {
    width: '50px',
    textAlign: 'center',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  selectContainer: {
    width: '50px',
  },
  select: {
    fontSize: '14px',
  },
});

AddedSugarsRow.propTypes = {
  quantity: PropTypes.string,
  uom: PropTypes.string,
  percentage: PropTypes.string,
  precisionCode: PropTypes.string,
  setNutritionAttributes: PropTypes.func,
  quantityAttribute: PropTypes.string,
  uomAttribute: PropTypes.string,
  percentageAttribute: PropTypes.string,
  precisionCodeAttribute: PropTypes.string,
};

export default AddedSugarsRow;
